///==============Station Types===================///

export const FETCH_STATIONS_REQUEST = "FETCH_STATIONS_REQUEST";
export const FETCH_STATIONS_SUCCESS = "FETCH_STATIONS_SUCCESS";
export const FETECH_STATIONS_FAIL = "FETECH_STATIONS_FAIL";
export const CHANGE_THE_STATION = "CHANGE_THE_STATION";
